/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useDatasetStatusLabelStyles = makeStyles(() => ({
  statusLabel: {
    cursor: 'default',
    pointerEvents: 'none',
    padding: '2px',
    marginLeft: '5px',
    fontSize: '10px',
    textAlign: 'center',
    borderRadius: '4px',
  },
  invisible: {
    color: '#fff',
    background: '#b3bcbf',
    minWidth: '49px',
    maxWidth: '49px',
  },
  notExist: {
    color: '#fff',
    background: 'rgba(255, 61, 61, 0.5)',
    minWidth: '50px',
    maxWidth: '50px',
  },
}));
